import { Flex } from 'component-library/components/layout/Flex';
import { Link } from 'component-library/components/links/Link';
import { Body } from 'component-library/components/typography/Body';
import { Screen, ShowOn } from 'component-library/components/wrappers/ShowOn';
import React, { FC } from 'react';
import styled from 'styled-components';

import { FooterProps, FooterTemplate } from '.';
import { FAQs } from './FAQs';
import { Legal } from './Legal';
import { Links } from './Links';
import { Socials } from './Socials';

const FooterSection = styled.div<{ borderBottom?: boolean }>`
  padding: 48px 20px;
  border-bottom: ${({ borderBottom = false }) =>
    borderBottom ? '1px solid rgba(38, 49, 59, 0.12)' : 'none'};
`;

const Accreditations = styled(FooterSection)`
  svg {
    margin-right: 16px;
  }
`;

const StyledLink = styled(Link)`
  flex: 1;
`;

export const FooterSmall: FC<FooterProps> = ({
  template,
  displayDepositAccountDetails,
  additionalFootnotes = [],
}) => {
  const isFull = template === FooterTemplate.Full;
  const isLegalDisclaimerOnly = template === FooterTemplate.LegalDisclaimerOnly;
  const isLegalDisclaimerAndContacts =
    template === FooterTemplate.LegalDisclaimerAndContacts;

  return (
    <ShowOn screens={[Screen.Sm, Screen.Md]}>
      {!isLegalDisclaimerOnly && (
        <FooterSection borderBottom>
          <Socials />
          <Links contactOnly={isLegalDisclaimerAndContacts} />
        </FooterSection>
      )}
      <FooterSection borderBottom>
        {isFull && <FAQs marginBottom={24} />}
        <Legal
          displayDepositAccountDetails={displayDepositAccountDetails}
          additionalFootnotes={additionalFootnotes}
        />
      </FooterSection>
      <Accreditations>
        <Body marginBottom={8} variant={5}>
          © 2024 Retirable Inc. All rights reserved.
        </Body>
        <Flex>
          <StyledLink to="/legal/terms-and-conditions" variant={5}>
            Terms and Conditions
          </StyledLink>
          <StyledLink to="/legal/privacy-policy" variant={5}>
            Privacy Policy
          </StyledLink>
        </Flex>
      </Accreditations>
    </ShowOn>
  );
};
